export default __webpack_public_path__ + "static/media/mainBgMom.66532bca.png";